import { render, staticRenderFns } from "./AppBindezFooterLogo.vue?vue&type=template&id=9c2a8c62&scoped=true&"
import script from "./AppBindezFooterLogo.vue?vue&type=script&lang=js&"
export * from "./AppBindezFooterLogo.vue?vue&type=script&lang=js&"
import style0 from "./AppBindezFooterLogo.vue?vue&type=style&index=0&id=9c2a8c62&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c2a8c62",
  null
  
)

export default component.exports